var _defs, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconInstargam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "prefix__Icon_-_Instargam",
    width: 24,
    height: 24,
    "data-name": "Icon - Instargam",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "prefix__radial-gradient",
    cx: -0.089,
    cy: 1.044,
    r: 1.845,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9ed41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.241,
    stopColor: "#ff833d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.401,
    stopColor: "#ee5468"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489,
    stopColor: "#e7407b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0028ff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "prefix__radial-gradient-2",
    cx: -0.665,
    cy: 1.575,
    r: 3.646,
    xlinkHref: "#prefix__radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "prefix__radial-gradient-3",
    cx: -6.104,
    cy: 6.76,
    r: 14.004,
    xlinkHref: "#prefix__radial-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_2464",
    fill: "none",
    d: "M0 0H24V24H0z",
    "data-name": "Rectangle 2464"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_5900",
    "data-name": "Group 5900",
    transform: "translate(-297.176 -298.499)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_8013",
    fill: "url(#prefix__radial-gradient)",
    d: "M312.277 318.5h-6.2a4.9 4.9 0 0 1-4.9-4.9v-6.2a4.9 4.9 0 0 1 4.9-4.9h6.2a4.9 4.9 0 0 1 4.9 4.9v6.2a4.9 4.9 0 0 1-4.9 4.9zm-6.2-14.6a3.369 3.369 0 0 0-3.5 3.5v6.2a3.369 3.369 0 0 0 3.5 3.5h6.2a3.369 3.369 0 0 0 3.5-3.5v-6.2a3.369 3.369 0 0 0-3.5-3.5z",
    "data-name": "Path 8013"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_8014",
    fill: "url(#prefix__radial-gradient-2)",
    d: "M324.253 329.623a4.047 4.047 0 1 1 4.047-4.047 4.052 4.052 0 0 1-4.047 4.047zm0-6.747a2.7 2.7 0 1 0 2.7 2.7 2.622 2.622 0 0 0-2.7-2.701z",
    "data-name": "Path 8014",
    transform: "translate(-15.077 -15.076)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_8015",
    fill: "url(#prefix__radial-gradient-3)",
    d: "M358.329 315.389a1.054 1.054 0 1 1-1.054-1.054 1.054 1.054 0 0 1 1.054 1.054z",
    "data-name": "Path 8015",
    transform: "translate(-43.886 -9.067)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInstargam);
export default __webpack_public_path__ + "static/media/icon-instargam.f200cf8ee668650e0d7865636ba8738e.svg";
export { ForwardRef as ReactComponent };